export const HEALTHY_CONTRIBUTIONS_INFO = 'info@healthycontributions.com';
export const HEALTHY_CONTRIBUTIONS_PRIVACY = 'privacy@healthycontributions.com';